import { useState, useEffect } from 'react';
import axiosInstance from '../api/axios-config';

/**
 * Hook pour récupérer le nombre d'alertes actives
 * Met à jour automatiquement toutes les 10 secondes
 */
export const useActiveAlertsCount = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchActiveAlertsCount = async () => {
      try {
        // Request all alerts since we need to filter by isBroadcasting locally
        const response = await axiosInstance.get('/alert-history?limit=10000');
        // Handle both array response (legacy) and paginated response {data: [...], total: ...}
        let alerts: any[] = [];
        if (response.data && Array.isArray(response.data)) {
          alerts = response.data;
        } else if (response.data && Array.isArray(response.data.data)) {
          alerts = response.data.data;
        }
        const activeCount = alerts.filter((alert: any) => alert.isBroadcasting).length;
        setCount(activeCount);
      } catch (error) {
        // Silently fail - don't show errors for this background task
      }
    };

    // Fetch immédiatement
    fetchActiveAlertsCount();

    // Puis toutes les 10 secondes
    const interval = setInterval(fetchActiveAlertsCount, 10000);

    return () => clearInterval(interval);
  }, []);

  return count;
};
